import get from 'lodash/get'
import { useCallback } from 'react'
import { useWeb3 } from 'modules/blockChain/hooks/useWeb3'

import { ADD_CHAIN_PARAMS } from 'modules/blockChain/chains'
import { DEFAULT_CHAIN } from 'config'

export function useSwitchNetwork() {
  const { library } = useWeb3()

  return useCallback(async () => {
    if (!library) return

    const switchChainId = `0x${DEFAULT_CHAIN.toString(16)}`

    try {
      await library.send('wallet_switchEthereumChain', [
        { chainId: switchChainId },
      ])
    } catch (error: any) {
      if (error?.code === 4902) {
        try {
          await library.send('wallet_addEthereumChain', [
            {
              chainId: switchChainId,
              ...get(ADD_CHAIN_PARAMS, DEFAULT_CHAIN),
            },
          ])
        } catch (addError) {
          console.error(addError)
        }
      }
    }
  }, [library])
}
